import React from 'react';
import './styles.scss';
import betaTag from '../../assets/images/beta-tag.png';
import { generateID } from '../../base/helper';
import { AIBetaTagType } from './types';

const AIBetaTag: React.FC<AIBetaTagType> = ({
  id = generateID('clientos-ui-toolkit-ai-beta-tag')
}) => {
  return (
    <div
      id={id}
      className="clientos-ui-toolkit-ai__container"
    >
      <img
        src={betaTag}
        id={`${id}__beta-tag`}
        className="clientos-ui-toolkit-ai__beta-tag"
        loading="eager"
        decoding="async"
      />
    </div>
  );
};

export default AIBetaTag;
